import ProductPage from "./[slug]/index";

// Partner links have no slug; they get the slug route's server-rendered props.
export {
  getPartnerLinkStaticPaths as getStaticPaths,
  getPartnerLinkStaticProps as getStaticProps,
} from "../../../components/product-main";

export default ProductPage
